{
  "settings": "Nastavitve",
  "yourDigitalAssistant": "Vaš digitalni asistent",
  "getStarted": "Začeti",
  "login": "Vpiši se",
  "loggingIn": "Prijavljanje ...",
  "darkMode": "Temni način",
  "clearHistory": "Izbriši zgodovino",
  "historyCleared": "Zgodovina izbrisana",
  "changeLanguage": "Jezik",
  "termsAndConditions": "Pogoji uporabe",
  "messagePlaceholder": "Vnesite svoje sporočilo tukaj ...",
  "messagePlaceholderDisabled": "Tipkanje onemogočeno ...",
  "feedbackTitle": "Ocenite svoje izkušnje",
  "feedbackPlaceholder": "Povejte nam o tem (neobvezno)",
  "feedbackSend": "Pošlji",
  "feedbackClose": "Zapri",
  "sessionExpired": "Vaša seja je potekla zaradi neaktivnosti.",
  "startNewSession": "Začnite novo sejo",
  "apiError": "Ups! Nekaj ​​je šlo narobe. Delamo na tem, da to popravimo čim prej.",
  "apiErrorOffline": "Niste povezani v internet.",
  "tryAgain": "Poskusi ponovno",
  "startOver": "Začeti znova",
  "chatEnded": "Klepet se je končal.",
  "chatEndedThankYou": "Hvala, ker ste klepetali z nami!",
  "closeChat": "Zapri",
  "startNewChat": "Spet klepet",
  "humanTakeoverStarted": "Zdaj ste premeščeni v službo za stranke ...",
  "humanTakeoverQueued": "Čakanje na povezavo z agentom",
  "humanTakeoverAnAgent": "Agent",
  "humanTakeoverAgentEntered": "je vstopil v pogovor",
  "humanTakeoverAgentLogout": "zapustil pogovor",
  "humanTakeoverTransfer": "Premeščeni ste v novega agenta",
  "humanTakeoverEnded": "Zdaj klepetate s svojim digitalnim asistentom",
  "version": "Različica",
  "formIntroText": "Za začetek klepeta z nami izpolnite naslednji obrazec.",
  "formFirstName": "Ime",
  "formLastName": "Priimek",
  "formName": "Ime",
  "formEmail": "E-naslov",
  "formWrongEmail": "Navedite veljaven e-poštni naslov.",
  "formPhone": "Telefon",
  "formShipmentId": "ID pošiljke",
  "formQuestion": "Tvoje vprašanje",
  "formAccountNumber": "Številka računa (za poslovne stranke)",
  "formAddress": "Naslov",
  "formPostcode": "Poštna številka",
  "formCity": "Mesto",
  "formCountry": "Država",
  "formSubmitButton": "Začni klepet",
  "formEmptyFieldError": "Ne sme biti prazno.",
  "formPhoneNumberValidationError": "Ni veljavna telefonska številka.",
  "formInputIsBiggerThan50": "Največ 50 znakov.",
  "formInputIsBiggerThan100": "Največ 100 znakov.",
  "formInputIsBiggerThan2000": "Največ 2000 znakov.",
  "widgetEventOnline": "Sporočilo DA: Uporabnik je spet povezan.",
  "widgetEventHidden": "Sporočilo DA: Pripomoček je skrit.",
  "widgetEventVisible": "Sporočilo DA: Pripomoček je viden.",
  "widgetEventVisibleMinimized": "Sporočilo DA: Pripomoček je viden, vendar zmanjšan.",
  "widgetEventMinimized": "Sporočilo DA: Pripomoček je minimiziran.",
  "widgetEventMaximized": "Sporočilo DA: Pripomoček je maksimiran.",
  "widgetEventSessionExpired": "Sporočilo DA: Seja pripomočkov je potekla.",
  "widgetEventHangupHuman": "Sporočilo DA: Uporabnik konča sejo človeškega prevzema.",
  "widgetEventUserTyping": "Sporočilo DA: uporabnik tipka.",
  "fileTooLarge": "Poskušate priložiti prevelike datoteke.",
  "tooManyDiles": "Poskušate priložiti preveč datotek.",
  "fileInvalidType": "Poskušali ste priložiti neveljavne vrste datotek.",
  "attachmentsDropHere": "Spustite sem, da naložite oz",
  "attachmentsBrowse": "Brskaj po datotekah",
  "attachmentsExtenstionQuantity": "pdf ali slike (do 10 datotek)",
  "attachmentsSize": "do 30 MB",
  "attachmentsFailedUploading": "Nalaganje ni uspelo",
  "attachmentsUploading": "Nalaganje ...",
  "minimizeExpandText": "Klepetajte v živo z nami zdaj!",
  "popupWidgetNotificationMessage": "Prejeli ste novo sporočilo!",
  "tabWidgetNotificationMessage": "Novo sporočilo!",
  "datepickerSendButton": "Pošlji"
}
